import { SideMenu } from "../models/SideMenu";
import {
  HomeRounded,
  PeopleAltRounded,
  KeyRounded,
  ApartmentRounded,
  CalendarMonthRounded,
  ConstructionRounded,
  CarRentalRounded,
  ScienceRounded,
  QuizRounded,
  Assignment,
  DocumentScanner,
  ReportProblemRounded,
  Checklist,
  Warning,
  WorkOutlined,
  Factory,
  Dashboard,
  Medication,
  FolderSharedRounded,
  TaskRounded,
} from "@mui/icons-material";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";

const ClientSiteMenu: SideMenu[] = [
  {
    label: "Dashboard",
    icon: Dashboard,
    link: "/dashboard",
    policy: "site-profile",
  },
  {
    label: "Action Plan For Compliance",
    icon: TaskRounded,
    link: "/task-view",
    policy: "client-task",
  },
  {
    label: "Safety File",
    icon: FolderSharedRounded,
    link: "/folder-shared",
    childMenu: [
      {
        label: "DSF",
        link: "/site-dsf-table",
        policy: "client-dsf",
      },
      {
        label: "Site DSF Poster",
        link: "/site-details/site-dsf-poster",
      },
    ],
  },
  {
    label: "Site Details",
    icon: PersonRoundedIcon,
    link: "/site-details",
    childMenu: [
      {
        label: "Details",
        link: "/site-details/details",
      },
      {
        label: "Client",
        link: "/site-details/client",
      },
      {
        label: "Professional Team",
        link: "/site-details/professional-team",
      },
      {
        label: "Schedule",
        link: "/site-details/schedule",
      },
      {
        label: "Site Documents",
        link: "/site-details/site-documents",
      },
    ],
  },
  {
    label: "Scope of Work",
    icon: WorkOutlined,
    link: "/scope-of-work",
    policy: "site-profile",
    childMenu: [
      {
        label: "Summary",
        link: "/scope-of-work/summary",
      },
      {
        label: "Job Task",
        link: "/scope-of-work/job-tasks",
      },
    ],
  },
  {
    label: "People & Attendance",
    icon: PeopleAltRounded,
    link: "/people-and-attendance",
    childMenu: [
      {
        label: "Attendance",
        link: "/attendance-table",
        policy: "client-attendance",
      },
      {
        label: "Emergency Contacts",
        link: "/emergency-contact",
        policy: "emergency-contact",
      },
      {
        label: "Organogram",
        link: "/site-organogram",
        policy: "client-organogram",
      },
      {
        label: "Employees",
        link: "/site-employee-table",
        policy: "client-employee",
      },
      {
        label: "Appointments",
        link: "/people-and-attendance/appointments",
        policy: "client-appointments",
      },
      {
        label: "Sub Contractors",
        link: "/people-and-attendance/sub-contractors",
        policy: "client-subcontractors",
      },
    ],
  },
  {
    label: "Assets & Resources",
    icon: Factory,
    link: "/assets-and-resources",
    childMenu: [
      {
        label: "Equipment",
        link: "/site-equipment-table",
        policy: "client-equipment",
      },
      {
        label: "Vehicles",
        link: "/site-vehicle-table",
        policy: "client-vehicle",
      },
      {
        label: "Chemicals",
        link: "/site-chemical-table",
        policy: "client-chemical",
      },
    ],
  },
  {
    label: "Safety & Operations",
    icon: Medication,
    link: "/operations",
    childMenu: [
      {
        label: "DSTI",
        link: "/site-dsti",
        policy: "client-dsti",
      },
      {
        label: "PTO",
        link: "/site-pto",
        policy: "client-pto",
      },
      {
        label: "Daily Task Plan (DTP)",
        link: "/daily-task-plan",
        policy: "client-dtp",
      },
      {
        label: "Inductions",
        link: "/site-induction",
        policy: "client-induction",
      },
      {
        label: "Checklists",
        link: "/site-checklist-submissions",
        policy: "client-checklists",
      },
      {
        label: "Incidents",
        link: "/site-incidents",
        policy: "client-incidents",
      },
    ],
  },
  // {
  //   label: "HIRA",
  //   icon: ReportProblemRounded,
  //   link: "/consultant-table",
  //   childMenu: [
  //     {
  //       label: "Hazards",
  //       link: "/risk-hazard-table",
  //     },
  //     {
  //       label: "Risks",
  //       link: "/hira/risk-assessments",
  //     },
  //   ],
  // },
  {
    label: "Policies & Procedures",
    icon: QuizRounded,
    link: "/template-table",
    policy: "client-template",
  },
];

export { ClientSiteMenu };
